import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, Inject, LOCALE_ID, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class DatePickerComponent implements OnInit {
  @Output() onCalendarShown = new EventEmitter();
  @Output() onCalendarHidden = new EventEmitter();
  @Input() placeholder:string;
  @Input() maxDate:Date;
  @Input() minDate:Date;

  insideCtrl:FormControl; // date value
  private subscriptions = new Subscription();

  constructor(
    private localeService:BsLocaleService,
    private cdRef:ChangeDetectorRef,
    @Inject(LOCALE_ID) public localeId: string    
  ) { 
    this.localeService.use(localeId);    

  }
  createControls () {
    const starts_at_date = new Date(this.value || Date.now());
    this.insideCtrl = new FormControl(this.fixTimezoneOffset(starts_at_date));
  }  
  private fixTimezoneOffset (d:Date):Date {
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0));    
  }
  ngOnInit(): void {
    this.createControls();

    this.subscriptions.add(
      this.insideCtrl.valueChanges
      .subscribe((date_from_picker:Date)=>{

        const date_from_outside = new Date(this.value);
        if (date_from_picker.toDateString() === date_from_outside.toDateString()) return;

        date_from_outside.setFullYear(date_from_picker.getFullYear(), date_from_picker.getMonth(), date_from_picker.getDate());
        this.value = date_from_outside.getTime();
        this.onChange(this.value)        
      })
    );
    this.insideCtrl.updateValueAndValidity();
  }
  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }





  value:number;
  disabled:boolean = false;  
  writeValue(value: number) {
    this.value = value;

    const date_from_outside = new Date(this.value);
    const date_from_picker:Date = new Date(this.insideCtrl.value && this.insideCtrl.value.getTime());
    if (date_from_picker.toDateString() === date_from_outside.toDateString()) return;
    
    date_from_picker.setFullYear(date_from_outside.getFullYear(), date_from_outside.getMonth(), date_from_outside.getDate());
    this.insideCtrl.setValue(date_from_picker)

    this.cdRef.detectChanges();
  }
  onChange = _ => {};
  onTouched = () => {};
  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


}
